/* eslint-disable react/no-array-index-key */

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * ListFilters
 *
 */
// import { FormattedMessage } from 'react-intl';
// import filterData from './fixtures/fixture.json';
// import messages from './messages';
import classNames from 'classnames'
import React from 'react'

import Icon from '../Icon'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  innerDiv: {
    display: 'inline-flex',
    width: 'auto',
    flexDirection: 'column',
  },
  formControl: {
    width: 'auto',
    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    '&>div>div': {
      width: 'auto',
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    '&:before': {
      // borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      // borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      // borderBottom: 'none !important',
    },
    '&:hover': {
      // borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div>div': {
      // width: `calc(100% - 14px)`,
      padding: '5px',
      // lineHeight: '1.5rem'
    },
  },
  stgLabel: {
    margin: `0  0 ${theme.spacing(4)} 0`,
    color: props => (props.isError ? theme.status.errorColor : 'unset'),
    transform: 'translate(0, 24px) scale(1)',
    '& +div': {
      marginTop: '10px',
    },
  },
  mandatory: {
    color: theme.status.errorColor,
  },
  errorP: {
    marginBottom: theme.spacing(4),
    color: theme.status.errorColor,
  },
  locked: {
    pointerEvents: 'none',
  },
  positionRelative: {
    position: 'absolute',
    right: 5,
    top: 7,
  },
})

/* eslint-disable react/prefer-stateless-function */
class DropDown extends React.Component {
  handleChange = event => {
    // eslint-disable-next-line prefer-destructuring
    const value = event.target.value
    // eslint-disable-next-line react/no-unused-state
    this.setState({ selected: value })
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(value)
  }

  render() {
    const {
      className,
      classes,
      defaultOption,
      label,
      isMandatory,
      isError,
      defaultValue,
      filterData,
      errorMessage,
      selected,
      locked,
      doNotShowLockIcon,
    } = this.props
    return (
      <div autoComplete="off" className={classNames(classes.root, className)} style={{ width: 'auto' }}>
        {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
        {filterData &&
          filterData.map((item, key) => (
            <div
              // style={{ width: '100%' }}
              key={`item${
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                key
              }`}
              className={classes.innerDiv}
            >
              {label && (
                <InputLabel htmlFor={label} className={classes.stgLabel}>
                  {label} {isMandatory && <span className={classes.mandatory}>*</span>}
                </InputLabel>
              )}
              <FormControl
                className={classes.formControl}
                innerRef={node => {
                  this.formControlNode = node
                }}
                error={isError}
              >
                <Select
                  value={selected}
                  onChange={this.handleChange}
                  displayEmpty
                  name={item.key}
                  className={classNames(classes.stgInput, locked ? classes.locked : null)}
                >
                  {defaultOption && (
                    <MenuItem value="">
                      <span>{defaultValue || 'All'}</span>
                    </MenuItem>
                  )}
                  {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
                  {item.value &&
                    item.value.map(option => (
                      <MenuItem
                        key={`itemIn${
                          // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                          key
                        }`}
                        value={option.id}
                      >
                        <span>{option.name}</span>
                      </MenuItem>
                    ))}
                </Select>
                {locked && !doNotShowLockIcon && (
                  <div className={classes.positionRelative}>
                    <Icon iconSize={15} iconName="lock" color="grey" />
                  </div>
                )}
              </FormControl>
              <FormHelperText className={classes.errorP} id={`${label}-error-text`}>
                {isError && errorMessage}
              </FormHelperText>
            </div>
          ))}
      </div>
    )
  }
}

DropDown.defaultProps = {
  onChange: () => {},
  className: {},
  filterData: [],
  selected: [],
  defaultOption: false,
  locked: false,
  doNotShowLockIcon: false,
}

const DropDownStyles = withStyles(styles)(DropDown)
DropDownStyles.displayName = 'Select'
export default DropDownStyles
